






































import { Vue, Component } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import APIService from '@/api';
import { getSignUpUrl } from '@/views/Onboarding/helpers';

@Component({
  components: {
    FlexButton,
    FilledButton
  }
})
export default class Manager extends Vue {
  get name() {
    return this.$store.getters['manager/getExtraInfo'].fullname.split(' ')[0];
  }

  createBusiness() {
    this.$router.push(getSignUpUrl());
  }

  logout() {
    APIService.resetCredentials();
  }
}
